<template>
  <div class="case">
    <banner img="../assets/img/banner.png"
            title="技术支持" />
    <div class="case-wrap">
      <el-row :gutter="20">
        <el-col :span="8"
                v-for="(item,index) in list"
                :key="index">
          <div class="case-item">
            <img class="case-img"
                 :src="imgFn(item.imgName)"
                 alt="">
            <div class="case-list-bottom">
              <h3 class="case-name">{{item.name}} </h3>
              <!-- <a v-if="index === 0"
                 target="_blank"
                 href="http://www.hzinfor.cn:8000/d/ba091ceafa5544e28a57/"
                 style="color:#2686ff">汉卓物联</a>
              <a v-else-if="index === 1"
                 target="_blank"
                 href="http://www.hzinfor.cn:8000/d/ecb3c54a6bff40c1ba5c/"
                 style="color:#2686ff">Android客户端</a>
              <p v-else>
                <a target="_blank"
                   href="https://restshdx.xbubao.com/client/android/android_shdx.apk"
                   style="color:#2686ff">Android客户端</a>
                &nbsp;&nbsp;&nbsp;&nbsp;<a target="_blank"
                   href="https://itunes.apple.com/us/app/布包云云协作/id1445816425?l=zh&amp;ls=1&amp;mt=8"
                   style="color:#2686ff">IOS客户端</a>
                &nbsp;&nbsp;&nbsp;&nbsp;<a target="_blank"
                   href="https://restshdx.xbubao.com/client/windows/setup.exe"
                   style="color:#2686ff">Windows客户端</a>
              </p> -->

            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Banner from '../components/Banner';
import zfImg from '../assets/kz/zf.png';
import lcImg from '../assets/kz/lc.png';
export default {
  components: {
    Banner,
  },
  data() {
    return {
      indexId: this.$route.query.id - 1,
      loading: false,

      list: [
        { id: 1, imgName: 'banner.png', name: '技术文档', des: '汉卓物联' },
        { id: 2, imgName: 'iot.jpg', name: '冷链IOT软件', des: 'Android客户端' },
        { id: 3, imgName: 'yxz.jpg', name: '云协作软件', des: '美团外卖送撒都快' },
      ],
    };
  },

  methods: {
    imgFn(name) {
      if (name) return require(`../assets/${name}`);
    },
    detailHandle(id) {
      this.$router.push(`/casedetails/${id}`);
    },
  },
};
</script>

 <style lang="scss" scoped>
a {
  text-decoration: auto;
}
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  &-wrap {
    display: flex;
    justify-content: center;
    margin: 40px 0;
  }
  &-item {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 24px;
    width: 100%;
    height: 400px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transition: all 0.5s;
    cursor: pointer;
  }
  &-list-bottom {
    background-color: #fff;
    padding: 40px;
    flex: 1;
    position: relative;
  }
  &-name {
    font-size: 24px;
    margin-bottom: 10px;
    height: 80px;
  }
  &-des {
    height: 80px;
  }
  &-img {
    width: 100%;
    height: 180px;
    max-width: 400px;
  }
}
.price {
  margin-top: 10px;
}
</style>